import React from 'react'
import {useStaticQuery, graphql} from 'gatsby'
import Post from './Post'
import {StPosts} from './style.css'

const Posts = () => {
	const allPostsTag = useStaticQuery (
		graphql`
		query (
      $tagslug: String = "especial-palestina"
    ) {
		allWordpressPost(
			filter: { tags: { elemMatch: { slug: { eq: $tagslug } } } }
			sort: { fields: date, order: ASC }
		) {
			edges {
				node {
					id
					title
					slug
					excerpt
					raw
					acf{
						imagen
						video
						creditos
					}
				}
			}
		}
	}
	`)

  return (
    <StPosts>
			{allPostsTag.allWordpressPost.edges.map(({node}, index) =>
				<Post key={index} firstitem={index === 0 ? true : false} post={node} />
			)
		}
    </StPosts>
  )
}

export default Posts